document.addEventListener('DOMContentLoaded', function () {
	var wrapper = document.querySelector(
		'.compare-mattresses__compare-card-wrapper'
	);
	var buttons = document.querySelectorAll('.compare-mattresses__nav-button');
	if (!wrapper || !buttons.length) return;

	// Click handlers
	buttons.forEach(function (btn) {
		btn.addEventListener('click', function () {
			var idx = btn.getAttribute('data-index');
			var target = document.getElementById(
				'compare-mattresses__compare-card--' + idx
			);
			if (!target) return;

			// Scroll the wrapper to bring the target into view. This will animate the wrapper.
			target.scrollIntoView({
				behavior: 'smooth',
				block: 'nearest',
				inline: 'center',
			});

			// set aria/current state
			buttons.forEach(function (b) {
				b.removeAttribute('aria-current');
			});
			// btn.setAttribute('aria-current', 'true');
		});
	});

	// Optional: update active button while user scrolls the wrapper (nice UX)
	var ticking = false;
	wrapper.addEventListener('scroll', function () {
		if (ticking) return;
		window.requestAnimationFrame(function () {
			updateActiveButton();
			ticking = false;
		});
		ticking = true;
	});

	function updateActiveButton() {
		var wrapperCenter = wrapper.scrollLeft + wrapper.clientWidth / 2;
		var closestBtn = null;
		var closestDist = Infinity;

		buttons.forEach(function (btn) {
			var idx = btn.getAttribute('data-index');
			var target = document.getElementById(
				'compare-mattresses__compare-card--' + idx
			);
			if (!target) return;
			var targetCenter = target.offsetLeft + target.offsetWidth / 2;
			var dist = Math.abs(targetCenter - wrapperCenter);
			if (dist < closestDist) {
				closestDist = dist;
				closestBtn = btn;
			}
		});

		if (closestBtn) {
			buttons.forEach(function (b) {
				b.removeAttribute('aria-current');
			});
			closestBtn.setAttribute('aria-current', 'true');
		}
	}

	// Initialize active button
	updateActiveButton();
});
